import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core"
import { restrictToVerticalAxis } from "@dnd-kit/modifiers"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"
import { ReactNode } from "react"

import { RowReordering } from "./types"

export interface SortableRowsProviderProps {
  rowReordering?: RowReordering
  children: ReactNode
}

export function SortableRowsProvider({
  rowReordering,
  children,
}: SortableRowsProviderProps) {
  const sensors = useSensors(useSensor(PointerSensor))

  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragStart={rowReordering?.onDragStart}
      onDragEnd={rowReordering?.onDragEnd}
      sensors={sensors}
      modifiers={[restrictToVerticalAxis]}
    >
      <SortableContext
        items={rowReordering?.rowKeys ?? []}
        strategy={verticalListSortingStrategy}
      >
        {children}
      </SortableContext>
    </DndContext>
  )
}
